// MultiPageHeroSingleImageNarrow is to support the legacy Hero from before the Website Hero Customization project
// web-wedding/src/components/publicWebsiteV2/pages/Home/Hero

import MultiPageHeroSingleImageNarrow from './MultiPageHeroSingleImageNarrow';

export default MultiPageHeroSingleImageNarrow;
